import getColour from '@lendi-ui/commons/colours';
import ChevronLeft from '@lendi-ui/icon/ChevronLeft';

import { useAnalytics } from '@funnels/providers';
import { run } from '@funnels/utils';

import { LinkButton } from '../LinkButton';

const LABEL = 'Back';

export const BackButton = () => {
  const { tracking } = useAnalytics();
  return (
    <LinkButton
      before={<ChevronLeft color={getColour('interaction', 'main')} height="24px" width="24px" />}
      onClick={run(
        () => window.history.back(),
        () => tracking?.button.link({ text: LABEL })
      )}
      text={LABEL}
    />
  );
};
